import { dataProps } from './properties'

export const setGenericContactList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
state.nav.page_number = payload.page_number
if(!state.nav.had_results) {
   state.nav.had_results = payload.total>0
}
}    

export const setGenericContactData = (state, payload) => {
    state.props = payload.response
} 

export const resetGenericContactData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/genericContact/mutations.js